import { defineStore } from 'pinia';
import { getBoothsFans } from '@/api/seller';

interface FansState {
  fansList: API.FanItem[]
  current: number
  size: number
  total: number
}

export const useSellerFans = defineStore('seller-fans', {
  state: (): FansState => ({
    fansList: [],
    current: 1,
    size: 10,
    total: 0,
  }),
  getters: {},
  actions: {
    async getFansList() {
      const res: any = await getBoothsFans();
      if (res) {
        this.fansList = res.data || [];
        this.current = res.current_page || 1;
        this.size = res.per_page || 10;
        this.total = res.total || 0;
      }
    },
  },
});
